import EntityType from "../../enum/EntityType";
import { ChatSendEmailAction, ChatSendEmailRecipient } from "../../types/chat/ChatContent";
import { EntityTypesSupportedByEmailFeature } from "../../types/entity";

import { CONTEXT_ENTITY_TYPES, isRecord } from "./chatWireGuards";

// The platform's own two recipient buckets. Their wire values are the EntityType values, so no
// mapping is needed downstream.
const RECIPIENT_ENTITY_TYPES: EntityTypesSupportedByEmailFeature[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
];

const parseSendEmailRecipient = (value: unknown): ChatSendEmailRecipient | undefined =>
  isRecord(value) &&
  typeof value.email === "string" &&
  typeof value.id === "number" &&
  typeof value.name === "string"
    ? { id: value.id, email: value.email, name: value.name }
    : undefined;

const parseSendEmailAction = (value: Record<string, unknown>): ChatSendEmailAction | undefined => {
  const entityType = CONTEXT_ENTITY_TYPES.find((candidate) => candidate === value.entityType);
  const email = value.email;
  if (
    typeof value.displayName !== "string" ||
    typeof value.entityId !== "number" ||
    !entityType ||
    !isRecord(email)
  ) {
    return undefined;
  }
  const recipientEntityType = RECIPIENT_ENTITY_TYPES.find(
    (candidate) => candidate === email.recipientEntityType
  );
  const recipients = Array.isArray(email.recipients)
    ? email.recipients.map(parseSendEmailRecipient)
    : undefined;
  if (
    !recipientEntityType ||
    typeof email.body !== "string" ||
    typeof email.subject !== "string" ||
    (email.sendAt !== undefined && typeof email.sendAt !== "string") ||
    !Array.isArray(email.recipientIds) ||
    email.recipientIds.length === 0 ||
    !email.recipientIds.every((id) => typeof id === "number") ||
    !recipients ||
    recipients.some((recipient) => !recipient)
  ) {
    return undefined;
  }
  return {
    displayName: value.displayName,
    email: {
      body: email.body,
      recipientEntityType,
      recipientIds: email.recipientIds as number[],
      recipients: recipients as ChatSendEmailRecipient[],
      ...(email.sendAt === undefined ? {} : { sendAt: email.sendAt }),
      subject: email.subject,
    },
    entityId: value.entityId,
    entityType,
    type: "send_email",
  };
};

export default parseSendEmailAction;
